import { put, call, takeLatest } from 'redux-saga/effects';
import { getUserOrders } from '~/common/redux/api';
import * as actions from '../actions';
import { GET_USER_ORDERS_REQUEST } from '../types';

export function* getUserOrdersSaga({ payload: { onSuccess } }) {
  try {
    yield put(actions.addLoader(GET_USER_ORDERS_REQUEST));
    const {
      data: { data: userOrders, success },
    } = yield call(getUserOrders);

    if (!success) {
      yield put(actions.getUserOrdersFailure());
    } else {
      yield put(actions.getUserOrdersSuccess(userOrders));
      onSuccess(userOrders);
    }
  } catch (e) {
    yield put(actions.getUserOrdersFailure());
  }
  yield put(actions.removeLoader(GET_USER_ORDERS_REQUEST));
}

const userOrdersSaga = [takeLatest(GET_USER_ORDERS_REQUEST, getUserOrdersSaga)];

export default userOrdersSaga;
